<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  label: string
  at: string
}>()

const formattedDate = computed<string>(() => {
  return new Date(props.at).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
})
</script>

<template>
  <div class="flex items-center gap-3 py-2" role="status" aria-live="polite">
    <div class="flex-1 h-px bg-slate-700" aria-hidden="true" />
    <span class="text-xs text-slate-500 whitespace-nowrap">
      {{ label }} &middot; {{ formattedDate }}
    </span>
    <div class="flex-1 h-px bg-slate-700" aria-hidden="true" />
  </div>
</template>
